import { render } from "./HistoryImport.vue?vue&type=template&id=1c679fe6"
import script from "./HistoryImport.vue?vue&type=script&lang=js"
export * from "./HistoryImport.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__